<template>
	<div>
		<ion-app v-if="ready">
			<ion-router-outlet />
		</ion-app>
	</div>
</template>

<script>
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { App } from '@capacitor/app';
import { Network } from '@capacitor/network';
import { SplashScreen } from '@capacitor/splash-screen';
import settings from "./WiseSettings";
import { run } from '@/store/AppState.js';
import { useSystemNotifications } from './helpers/useSystemNotifications'

export default defineComponent({
	setup() {
		useSystemNotifications()
	},
	//mixins: IMPORTANT! LOAD APP MIXINS IN MAIN.JS
	components: {
		IonApp,
		IonRouterOutlet,
	},
	data: () => ({
		ready: false,
		networkStatus: true,
		networkListener: null,
		intervalBackgroundGPS: null,
	}),
	computed: {
		...mapGetters({ 
			activeHost: 'common/activeHost',
			loggedIn: 'user/loggedIn',
		}),
		mainClass() {
			const activeHost = this.activeHost;
			let classes = [];

			if (activeHost.className) {
				classes = activeHost.className.split(' ')
			}

			if (settings.defaultClassName) {
				classes = [
					...classes, 
					...settings.defaultClassName.split(' ') 
				]
			}
			
			return Array.from(new Set(classes));
		}
	},
	watch: {
		networkStatus() {
			if(this.networkStatus.connected === false) {
				// If network status changes to not connected show error toast
				this.showToast(this.$t("errors.noNetwork"), this.$t("errors.noNetworkText"), "danger")
			}
		},
	},
	async mounted() {		
		this.mainClass.forEach(row => document.body.classList.add(row))
		
		if(Capacitor.getPlatform() === "ios") {
			// On iOS show done button when keyboard is open
			await Keyboard.setAccessoryBarVisible({ isVisible: true });
		}

		window.addEventListener('ionKeyboardDidShow', () => {
			document.querySelector('#app').classList.add('keyboard-visible')
		})

		window.addEventListener('ionKeyboardDidHide', () => {
			document.querySelector('#app').classList.remove('keyboard-visible')
		})

		window.addEventListener('resize', () => {
			const isMobile = window.innerWidth <= 768;
			
			this.$store.commit('res_common/setMobile', isMobile)
		}, { passive: true })

		App.addListener('appStateChange', async (state) => {
			if (state.isActive === true) {
				run({ isActive: true })
			} else {
				run({ isActive: false, loggedIn: false })
			}
		});

		// Monitor network status (used to inform user when internet connection lost)
		this.networkListener = Network.addListener('networkStatusChange', (status) => {
			this.networkStatus = status
		});
		this.networkStatus = await Network.getStatus();

		this.ready = true;
		await SplashScreen.hide();
		// APP mounted() ends
	},
});
</script>
